module.exports = __webpack_public_path__ + "static/media/thegfb-mobiles-tiny.d5f2034f.jpg";